import { z } from 'zod';
export const UUIDSchema = z.string();
export const ISODateSchema = z.string();
export const ISODateTimeSchema = z.string();
